<template>
  <v-card>
    <v-toolbar>
      <v-btn small class="mr-8" @click="expanded = !expanded">
        <v-icon left>fal fa-chevron-circle-{{ expanded ? 'down' : 'right' }}</v-icon>
        {{ show.name }}
      </v-btn>
      <v-spacer />
      <v-btn small class="mr-4" @click="$emit('edit')">
        <v-icon left>fal fa-edit</v-icon>
        Edit Show
      </v-btn>
    </v-toolbar>
    <v-card-text v-if="expanded">
      <v-data-table :items="performances" :headers="headers" hide-default-footer>
        <template #item.reserved="{ item }">
          <v-btn :to="'/theatre/tickets/' + item._id">{{ item.reserved }}</v-btn>
        </template>
      </v-data-table>
    </v-card-text>
  </v-card>
</template>
<script>
import { ref, computed } from '@vue/composition-api'

export default {
  props: {
    show: { type: Object, required: true }
  },
  setup (props, { root }) {
    const expanded = ref(true)
    const headers = ref([
      { text: 'Performance Date', value: 'dateStr' },
      { text: 'Seats', value: 'tickets' },
      { text: 'Reserved', value: 'reserved' },
      { text: 'Seats Left', value: 'seatsLeft' },
      { text: 'Covenant Student', value: 'Covenant Student' },
      { text: 'Covenant Faculty/Staff', value: 'Covenant Faculty/Staff' },
      { text: 'Community Adult', value: 'Community Adult' },
      { text: 'Community Student/Elder', value: 'Community Student/Elder' }
    ])
    const performances = computed(() => props.show.performances.map((row) => {
      const dt = new Date(row.date)
      const date = dt.toLocaleDateString('en-US', { weekday: 'short', year: 'numeric', month: 'long', day: 'numeric' })
      const time = dt.toLocaleTimeString('en-US', { hour: 'numeric', minute: '2-digit', timeZone: 'America/New_York' })
      row.dateStr = `${date} at ${time}`
      row.seatsLeft = row.tickets - row.reserved
      for (const { label, price, limit } of row.prices) {
        row[label] = `$${price}` + (limit ? ` - ${limit} Ticket Limit` : '')
        const rec = headers.value.find(({ text }) => text === label)
        if (!rec) {
          headers.value.push({ text: label, value: label })
        }
      }
      return row
    }).sort((a, b) => a.date < b.date ? -1 : 1))

    return {
      expanded,
      performances,
      headers
    }
  }
}
</script>
